import { PointRuleAdminForm } from "./point-rule-admin-form";
import { PointRuleAdminHandler } from "./point-rule-admin-handler";
import { PointRuleAdminListener } from "./point-rule-admin-listener";

export class PointRuleAdminSetup {
    public form: PointRuleAdminForm;

    public handler: PointRuleAdminHandler;

    public listener: PointRuleAdminListener;

    public constructor(root: HTMLElement) {
        this.form = new PointRuleAdminForm(root);
        this.handler = new PointRuleAdminHandler(this.form);
        this.listener = new PointRuleAdminListener(this.form, this.handler);
    }

    public init(): void {
        if (this.form.isInitialized()) {
            return;
        }

        this.listener.register();
        this.form.markInitialized();
    }

    public static init(scope: ParentNode = document): void {
        const root = scope instanceof HTMLElement || scope instanceof Document ? scope : document;
        const targets: HTMLElement[] = [];

        if (root instanceof HTMLElement && root.matches(".point-rules-admin")) {
            targets.push(root);
        }

        PointRuleAdminForm.getRoots(root).forEach((node) => {
            if (node instanceof HTMLElement) {
                targets.push(node);
            }
        });

        for (const target of targets) {
            const setup = new PointRuleAdminSetup(target);
            setup.init();
        }
    }
}
